module.exports = __webpack_public_path__ + "static/img/06.3180bfd9.png";